import axios, {AxiosResponse} from "axios";
import {ENV} from "../utils/env";


const axiosClient = axios.create({
    baseURL: new URL(ENV.REACT_APP_API_POINT!, ENV.REACT_APP_API_HOST).toString(),
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
});

axiosClient.interceptors.response.use(
    function (response: AxiosResponse) {
        return response;
    },
    function (error) {
        if (error?.response?.status === 401) {
            localStorage.removeItem('Replan.userToken');
            localStorage.removeItem('Replan.userName');
            window.location.href = '/signin'
        }
        return Promise.reject(error);
    }
);

export default axiosClient;